import styled from 'styled-components'

export const Separator = styled.hr`
  border: 1px solid #e6ecf0;
  width: 100%;
`
